import InboxEmailContentProp from "./InboxMailContent";
import { TabPane } from "reactstrap";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../../../../reduxToolkit/hooks";
import { setPage } from "../../../../../reduxToolkit/reducers/letterBoxSlice";
import { Href } from "../../../../../constants";
const Inbox = () => {
  const { inboxEmail, page } = useAppSelector((state) => state.letterBox);
  const dispatch = useAppDispatch();
  const handlePagination = (value: boolean) => dispatch(setPage(value));

  return (
    <TabPane tabId="1" >
      <div className="mail-body-wrapper">
        <ul>
          {inboxEmail.map((data, i) => (
            <li className={`inbox-data ${page ? i < 8 ? "hidden" : "" : i < 8 ? "" : "hidden" }`} key={i}>
              <InboxEmailContentProp data={data} ids={i} />
            </li>
          ))}
        </ul>
        <Pagination className="mail-pagination pagination-primary pagination">
          <PaginationItem onClick={() => handlePagination(false)}>
            <PaginationLink href={Href} previous />
          </PaginationItem>
          <PaginationItem active={!page ? true : false} onClick={() => handlePagination(false)}>
            <PaginationLink href={Href}>1</PaginationLink>
          </PaginationItem>
          <PaginationItem active={page ? true : false} onClick={() => handlePagination(true)}>
            <PaginationLink href={Href}>2</PaginationLink>
          </PaginationItem>
          <PaginationItem onClick={() => handlePagination(true)}>
            <PaginationLink href={Href} next />
          </PaginationItem>
        </Pagination>
      </div>
    </TabPane>
  );
};

export default Inbox;
